import React, {useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

function AddFolderDialog(props) {
  const { isOpen, closeDialog, addFolder, className, id, ...dialogProps } = props;
  const [folder, setFolder] = useState({name: '', description: ''});
  // const [name, setName] = useState('');
  // const [description, setDescription] = useState('');

  const handleClose = () => {
    closeDialog();
    setFolder({name: '', description: ''});
    // setName('');
    // setDescription('')
  }

  const handleSave = () => {
    if(folder.name) {
      addFolder(folder.name, folder.description);
    }
    closeDialog(folder.name);
    setFolder({name: '', description: ''});
  }

  return (
    <Dialog {...dialogProps} PaperProps={{id:id}} className={`add-folder-dialog ${className}`} open={isOpen} fullWidth maxWidth="md">
      <DialogTitle>
        <div style={{display:'flex', flexWrap:'wrap-reverse', justifyContent:'space-between'}}>
          Add Folder
          <IconButton onClick={handleClose} style={{width:'2rem', height:'2rem', margin:'-0.5rem 0 0 auto'}}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <form noValidate autoComplete="off">
          <TextField
            id="newFolderName"
            variant="outlined"
            size="small"
            style={{width: "100%"}}
            label="Name"
            value={folder.name}
            onChange={event => setFolder({...folder, name: event.target.value})}
          />
          <div style={{marginTop: "1rem", marginBottom: "1rem"}}>
            <TextField
              id="newFolderDescription"
              variant="outlined"
              label="Description"
              multiline={true}
              style={{width: "100%"}}
              minRows={5}
              value={folder.description}
              onChange={event => setFolder({...folder, description: event.target.value})}
            />
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button id="addFolderSave" onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
        <Button id="addFolderCancel" onClick={handleClose} variant="contained" color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddFolderDialog;
